import { useEffect } from "react";
import Lenis from "lenis";

const LENIS_DURATION_S = 1.25;
const lenisEasing = (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t));

// Lenis must be initialised exactly once for the lifetime of the app shell.
// The effect owns its own requestAnimationFrame loop and tears it down on
// unmount. `Lenis`, `cancelAnimationFrame`, `requestAnimationFrame`, and the
// locally-scoped `lenis` / `rafId` are intentionally not dependencies.
export default function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: LENIS_DURATION_S,
      smoothWheel: true,
      easing: lenisEasing,
    });

    let rafId = 0;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}
